import React from "react";
import { Link } from "react-router-dom";
import brand from "../content/brand";
import services from "../content/services";

const Footer = () => (
  <footer className="foot">
    <div className="shell">
      <div className="grid">
        <div className="lead-block">
          <img src="/brand/btcruka-logo.png" alt={brand.name} className="footer-logo" />
          <p>{brand.pitch}</p>
        </div>

        <div>
          <h5>Services</h5>
          {services.slice(0, 6).map((s) => (
            <Link key={s.slug} to={`/services/${s.slug}`}>{s.title}</Link>
          ))}
        </div>

        <div>
          <h5>More</h5>
          {services.slice(6).map((s) => (
            <Link key={s.slug} to={`/services/${s.slug}`}>{s.title}</Link>
          ))}
        </div>

        <div>
          <h5>Studio</h5>
          <Link to="/work">Selected work</Link>
          <Link to="/about">About</Link>
          <Link to="/contact">Contact</Link>
          <a href={`mailto:${brand.contact.email}`}>{brand.contact.email}</a>
        </div>
      </div>

      <div className="colophon">
        <span>© {new Date().getFullYear()} {brand.fullName}. All rights reserved.</span>
        <span>{brand.hq.city} · {brand.hq.country}</span>
      </div>
    </div>
  </footer>
);

export default Footer;
